import axios from 'axios'

export class ApiService{
    constructor(){
        this.API_URL = "https://vuldha.com/infomgmt/";
        this.client = axios.create({
            headers: {
                "X-Requested-With": "XMLHttpRequest"
            },
            baseURL: "/"
        });
    }
}